import React, { useState, useEffect } from 'react';
import '../css/Footer.css';
import { ReactComponent as LogoWhite } from '../assets/chunks-logo-white.svg';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  
  return (
    <footer className="footer">


        <div className="footer-logo">
                <NavLink to="/Contact">
                  <LogoWhite />
                </NavLink>
        </div>
          
        <div className="footer-text">
          <p>© 2025 Chunks Bakes. All rights reserved.</p>
          <p>HQ: Westbroekstraat 12, Amsterdam</p>
          <p>Shop: Van Woustraat 138 H, Amsterdam</p>
        </div>

    </footer>
  );
};

export default Footer;
